
export const conatinerSty  = {
    backgroundColor: "#fff",
    marginTop: "20px",
    marginBottom: "10px",
    borderRadius: "10px",
}